module.exports = __webpack_public_path__ + "img/180.87a3e6c9.jpg";